__turbopack_context__.v({
  "card": "index-module-scss-module__oo0veq__card",
  "carousel": "index-module-scss-module__oo0veq__carousel",
  "container": "index-module-scss-module__oo0veq__container",
  "count--2": "index-module-scss-module__oo0veq__count--2",
  "count--3": "index-module-scss-module__oo0veq__count--3",
  "count--4": "index-module-scss-module__oo0veq__count--4",
  "raw-items": "index-module-scss-module__oo0veq__raw-items",
  "title": "index-module-scss-module__oo0veq__title",
});
